import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  colors: {
    brand: {
      50: '#FFF8F0',
      100: '#FFF3E3',
      200: '#FFE8CC',
      300: '#FFD6AA',
      400: '#FFC488',
      500: '#FD984F', // Primary orange color
      600: '#F27B36',
      700: '#E45E1F',
      800: '#D7410D',
      900: '#C82500',
    },
  },
  fonts: {
    heading: "'Poppins', sans-serif",
    body: "'Poppins', sans-serif",
  },
  components: {
    Button: {
      baseStyle: {
        fontWeight: "500",
        borderRadius: "42px",
      },
      variants: {
        solid: {
          bg: "#FFF3E3",
          color: "#202020",
          _hover: {
            bg: "#FFE8CC",
          },
          _active: {
            bg: "#FFD6AA",
          },
        },
        outline: {
          borderRadius: "full",
        },
      },
    },
    Input: {
      variants: {
        filled: {
          field: {
            bg: "#F2F3F3",
            borderRadius: "42px",
            height: "72px",
            fontFamily: "'Poppins', sans-serif",
            fontSize: "18px",
            _hover: {
              bg: "#F2F3F3",
            },
            _focus: {
              bg: "#F2F3F3",
              borderColor: "#FD984F",
            },
          },
        },
      },
      defaultProps: {
        variant: "filled",
      },
    },
  },
});

export default theme;